module.exports = __webpack_public_path__ + "assets/img/drawItem1-a8433e9a.png";